<template>
  <div class="flex flex-col gap-32 md:flex-row">
    <!-- Horizontal under medium screens -->
    <div class="flex items-center gap-12 md:hidden">
      <RevDivider class="grow" />
      <IconPlus class="shrink-0" />
      <RevDivider class="grow" />
    </div>

    <!-- Vertical from medium screens -->
    <div class="hidden min-w-[110px] flex-col items-center gap-12 md:flex">
      <RevDivider class="grow" variant="vertical" />
      <IconPlus class="shrink-0" />
      <RevDivider class="grow" variant="vertical" />
    </div>

    <div class="grow"><slot /></div>
  </div>
</template>

<script setup lang="ts">
import { RevDivider } from '@ds/components/Divider'
import { IconPlus } from '@ds/icons/IconPlus'
</script>
